import { Link, NavLink } from "react-router-dom";
import {
  HOMEPAGE,
  BOUNAKIR,
  CONVERSTAION,
  EDIT_PROFILE,
  MY_PROFILE,
  BOUNAKIR_WATCH_ME,
} from "../navigation/Constants";
import {
  BounakirFilterType,
  GAActions,
  GACategoryName,
  GAEventNames,
  GAUniqueEventIds,
  HomeScreenType,
} from "../helpers/Enums";
import { useDispatch, useSelector } from "react-redux";
import {
  setBounkairCarpetFilterCategory,
  setHomeCurrentView,
} from "../redux/carpet";
import { useEffect, useLayoutEffect, useState } from "react";
import { RootState } from "../redux/store";
import { BOUNKIR_LINKS } from "./../navigation/Constants";
import { bonakirNotifications } from "../typings/member";
import { recordGaEvent } from "../helpers/GoogleAnalytics";

export interface BottomNavProps {
  screenType: HomeScreenType;
}

const BottomNav = ({ screenType }: BottomNavProps) => {
  const dispatch = useDispatch();
  const setCurrnetView = (view: HomeScreenType) =>
    dispatch(setHomeCurrentView(view));
  const { unreadMessageCount } = useSelector(
    (state: RootState) => state.member
  );
  const { newDoubleMatchesCount, newSentToMeCount, newWatchCount } =
    useSelector((state: RootState) => state.member.bonakirNotifications);

  const recordChatEvent = () => {
    recordGaEvent(
      GAEventNames.APP_ENGAGMENT,
      GACategoryName.SOCIAL_SCREEN,
      GAActions.CHAT,
      "open_chat",
      GAUniqueEventIds.APP_ENGAGMENT
    );
  };

  const IsUnreadBonakirNotif =
    newDoubleMatchesCount + newSentToMeCount + newWatchCount > 0;

  const setMenu = () => {
    dispatch(
      setBounkairCarpetFilterCategory({
        // value: BounakirFilterType.BOUNAKIR_NEMU,
        value: BounakirFilterType.WATCHE_ME,
        text: "היכרויות",
      })
    );
  };

  useLayoutEffect(() => {
    setCurrnetView(screenType);
  }, []);

  //TODO: Just for testing
  useEffect(() => {
    console.log({ screenType });
  }, [screenType]);

  return (
    <div className="nav_sec wf-section">
      <NavLink
        className={
          screenType === HomeScreenType.HOME
            ? "nav_link w-inline-block"
            : "nav_link grey w-inline-block"
        }
        to={HOMEPAGE}
      >
        <div className="nav_icon">
          <img
            src="/assets/images/nav_ic_home.svg"
            loading="lazy"
            alt="home_nav"
          />
        </div>
        <div>אנשים</div>
      </NavLink>
      <div className="nav_line" />
      <div onClick={recordChatEvent} className="nav_block">
        <NavLink
          className={
            screenType === HomeScreenType.CONVERSTAION
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          to={CONVERSTAION}
        >
          <div className="nav_icon">
            <img
              src="/assets/images/nav_ic_chat.svg"
              loading="lazy"
              alt="home_nav"
            />
          </div>
          <div>צ'אט</div>
        </NavLink>
        {unreadMessageCount > 0 ? (
          <div className="message_num">
            <div>{unreadMessageCount}</div>
          </div>
        ) : null}
      </div>
      <div className="nav_line" />
      {/* <div className="nav_block">
                <NavLink className={screenType === HomeScreenType.BOUNAKIR ? "nav_link w-inline-block" : "nav_link grey w-inline-block"} onClick={setMenu} to={BOUNAKIR}>
                    <div className="nav_icon">
                        <img src="/assets/images/nav_ic_shoshke.svg" loading="lazy" alt="home_nav" />
                    </div>
                    <div>היכרויות</div>
                </NavLink>
                {IsUnreadBonakirNotif && <div className="message_new">
                    <div>חדש</div>
                </div>}
            </div> */}
      {/* <div className="nav_block">
        <NavLink
          className={
            screenType === HomeScreenType.BOUNAKIR
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          onClick={setMenu}
          to={BOUNAKIR_WATCH_ME}
        >
          <div className="nav_icon">
            <img
              src="/assets/images/nav_ic_shoshke.svg"
              loading="lazy"
              alt="home_nav"
            />
          </div>
          <div>צפיות</div>
        </NavLink>
        {IsUnreadBonakirNotif && (
          <div className="message_new">
            <div>חדש</div>
          </div>
        )}
      </div> */}

      <div className="nav_block">
        <NavLink
          className={
            screenType === HomeScreenType.BOUNAKIR_WATCH_ME
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          onClick={setMenu}
          to={BOUNAKIR_WATCH_ME}
        >
          <div className="nav_icon">
            <img
              // src="/assets/images/nav_ic_shoshke.svg"
              src="/assets/images/nav_ic_views.svg"
              loading="lazy"
              alt="home_nav"
            />
          </div>
          <div>צפו בי</div>
        </NavLink>
        {IsUnreadBonakirNotif && (
          <div className="message_new">
            <div>חדש</div>
          </div>
        )}
      </div>

      <div className="nav_line" />

      <NavLink
        className={
          screenType === HomeScreenType.BOUNKIR_LINKS
            ? "nav_link w-inline-block"
            : "nav_link grey w-inline-block"
        }
        // to={BOUNKIR_LINKS}
        to={{ pathname: "https://www.motke.co.il/%D7%A2%D7%96%D7%A8%D7%94" }}
        target="_blank"
        onTouchStart={(e) => {
          e.currentTarget.style.color = "initial";
          e.currentTarget.style.filter = "saturate(16%) hue-rotate(204deg)";
        }}
      >
        {/* <div className="nav_icon motke">
                    <img src="/assets/images/nav_ic_motke.svg" loading="lazy" alt="motke_nav" />
                </div>
                <div>מוטק'ה</div> */}

        <div className="nav_icon motke">
          <img
            // src="/assets/images/nav_ic_motke.svg"
            src="/assets/images/nav_ic_motke_1.svg"
            loading="lazy"
            alt="motke_nav"
          />
        </div>
        <div>עזרה</div>
      </NavLink>

      <div className="nav_line" />
      <NavLink
        className={
          screenType === HomeScreenType.MY_PROFILE
            ? "nav_link w-inline-block"
            : "nav_link grey w-inline-block"
        }
        to={MY_PROFILE}
      >
        <div className="nav_icon profile">
          <img
            src="/assets/images/nav_ic_profile.svg"
            loading="lazy"
            alt="profile_nav"
          />
        </div>
        <div>פרופיל</div>
      </NavLink>
    </div>
  );
};

export default BottomNav;
